/**
 * BRANDING — la pagina di amministrazione: si sceglie l'azienda e la si veste.
 *
 * ⚠️ Il contenuto vive in `features/admin/BrandingEditor`, perché dal 25-09-2026 lo monta anche
 * la sezione «Branding» della scheda azienda. Qui resta la rotta e la scelta dell'azienda
 * (`withPicker`), che è ciò che distingue questa pagina da quella: là l'azienda è già decisa.
 */
import { createFileRoute } from '@tanstack/react-router';
import { BrandingEditor } from '@/features/admin/BrandingEditor';

export const Route = createFileRoute('/_app/admin/branding')({ component: BrandingRoute });

function BrandingRoute() {
  return <BrandingEditor withPicker />;
}
